import React from 'react';
import styled, { css } from 'styled-components';
import Button from '@ingka/button';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { mediaQueries } from '../styles/mediaQueries';
import { colors } from '../styles';
import { handlePrev } from '../helpers/urlHelper';
import { useStateSelector } from '../store';

export interface AppFooterProps {
  prevVisible?: boolean;
  nextVisible?: boolean;
  nextDisabled?: boolean;
  nextText?: string;
  isLoading?: boolean;
  formId?: string;
}

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  max-width: 500px;
`;

const StyledDivider = styled.div`
  margin: 1.5rem 0 1rem;
  border-top: 1px solid ${colors.neutral.grey200};

  ${mediaQueries.landscapePhoneUp} {
    margin: 2.5rem 0 1rem;
  }

  ${mediaQueries.desktopUp} {
    margin: 2.5rem 0;
  }
`;

const buttonStyle = css`
  width: 48%;
  max-width: 234px;
`;

const PrevButton = styled(Button)`
  ${buttonStyle};
  justify-content: center;
`;

const NextButton = styled(Button)`
  ${buttonStyle};
  margin-left: auto;
`;

const AppFooter: React.FC<AppFooterProps> = ({
  prevVisible,
  nextVisible,
  nextDisabled,
  nextText,
  isLoading,
  formId,
}): JSX.Element => {
  const { t } = useTranslation();
  const operation = useStateSelector((state) => state.app.operation);
  const nextBtnText = nextText || t('components.appFooter.next');

  return (
    <>
      <StyledDivider />
      <ButtonContainer>
        {prevVisible && (
          <PrevButton
            disabled={isLoading}
            onClick={() => handlePrev(operation)}
            text={t('components.appFooter.prev')}
            type="tertiary"
            data-cy="previous"
          />
        )}

        {nextVisible && (
          <NextButton
            htmlType="submit"
            form={formId}
            disabled={nextDisabled}
            loading={isLoading}
            text={nextBtnText}
            type="emphasised"
            id="nextbutton"
            data-cy="next-button"
          />
        )}
      </ButtonContainer>
    </>
  );
};

export default AppFooter;
